import { render, staticRenderFns } from "./TenantArrearsPanel.vue?vue&type=template&id=8ca11262&scoped=true"
import script from "./TenantArrearsPanel.vue?vue&type=script&lang=js"
export * from "./TenantArrearsPanel.vue?vue&type=script&lang=js"
import style0 from "./TenantArrearsPanel.vue?vue&type=style&index=0&id=8ca11262&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8ca11262",
  null
  
)

export default component.exports